import axios from "axios"
import { Toast } from 'vant'
let service1 = axios.create({
    baseURL: '/Mbusiness',
    timeout: 30000,
    headers: {
        'Content-Type': 'multipart/form-data'
    }
});
// 请求拦截器
service1.interceptors.request.use(function (config) {
    return config;
});
// 响应拦截器
service1.interceptors.response.use(function (response) {
    if (response.data.code == -1) {
        Toast(response.data.msg);
        return response;
    }else {
        return response.data;
    }
}, function (error) {
    return Promise.reject(error);
});
export default service1